module.exports = __webpack_public_path__ + "media/images/battery_empty-676b2a1818635de9a4c762c5eef25d63.png";